export const Info1 = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
    <g clipPath="url(#clip0_2408_7626)">
      <path d="M8.00001 0C8.14376 0 8.28751 0.03125 8.41876 0.090625L14.3031 2.5875C14.9906 2.87813 15.5031 3.55625 15.5 4.375C15.4844 7.475 14.2094 13.1469 8.82501 15.725C8.30314 15.975 7.69689 15.975 7.17501 15.725C1.79064 13.1469 0.515639 7.475 0.500014 4.375C0.496889 3.55625 1.00939 2.87813 1.69689 2.5875L7.58439 0.090625C7.71251 0.03125 7.85626 0 8.00001 0ZM8.00001 2.0875V13.9031C12.3125 11.8125 13.4719 7.19062 13.5 4.41875L8.00001 2.0875Z" fill="#2563EB"/>
    </g>
    <defs>
      <clipPath id="clip0_2408_7626">
        <rect width="16" height="16" fill="white"/>
      </clipPath>
    </defs>
  </svg>
  );
};

export const Info2 = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="14" height="16" viewBox="0 0 14 16" fill="none">
        <g clipPath="url(#clip0_2408_7631)">
          <path d="M4.5 4.5V6H9.5V4.5C9.5 3.11875 8.38125 2 7 2C5.61875 2 4.5 3.11875 4.5 4.5ZM2.5 6V4.5C2.5 2.01562 4.51562 0 7 0C9.48438 0 11.5 2.01562 11.5 4.5V6H12C13.1031 6 14 6.89687 14 8V14C14 15.1031 13.1031 16 12 16H2C0.896875 16 0 15.1031 0 14V8C0 6.89687 0.896875 6 2 6H2.5Z" fill="#2563EB"/>
        </g>
        <defs>
          <clipPath id="clip0_2408_7631">
            <rect width="14" height="16" fill="white"/>
          </clipPath>
        </defs>
      </svg>
    );
  };